var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-success is-fullheight",attrs:{"id":"game"}},[_c('canvas',{ref:"gameCanvas",attrs:{"id":"gameCanvas","width":"800","height":"600"}})])}
var staticRenderFns = []

export { render, staticRenderFns }